import { ASSET_PREFIX } from 'utils/constants';
import styles from './SocialLoginButton.module.css';

interface SocialLoginButtonProps {
  imageSrc: string;
  text: string;
  onClick: () => void;
  loading: boolean;
}
const SocialLoginButton = (props: SocialLoginButtonProps) => {
  return (
    <button
      className={
        styles.socialLoginButton + ' ' + (props.loading ? styles.loading : '')
      }
      onClick={props.onClick}
    >
      <span className={styles.socialLoginButtonInner}>
        <img className={styles.logo} src={props.imageSrc} alt={props.text} />
        <span className={styles.socialLoginButtonText}>{props.text}</span>
        <img
          className={styles.loadingIndicator}
          src={`${ASSET_PREFIX}/images/spinner-black.svg`}
          alt="Loading..."
        />
      </span>
    </button>
  );
};

export default SocialLoginButton;
